const remoteConfigLifecyclePlugin = ({ remoteConfig, remoteConfigAtom, port, }) => {
    let unobserveRemoteConfig;
    const sync = (config) => port.emit('remoteConfig', config ?? Object.create(null));
    const onLoad = async () => {
        const { config } = await remoteConfigAtom.get();
        sync(config);
    };
    const onStart = () => {
        unobserveRemoteConfig = remoteConfigAtom.observe(({ config }) => sync(config));
        void remoteConfig.load();
    };
    const onStop = () => {
        unobserveRemoteConfig?.();
        remoteConfig.stop();
    };
    const onUnlock = async () => {
        const { config } = await remoteConfigAtom.get();
        sync(config);
    };
    return { onLoad, onUnlock, onStart, onStop };
};
const remoteConfigPlugin = {
    id: 'remoteConfigPlugin',
    type: 'plugin',
    factory: remoteConfigLifecyclePlugin,
    dependencies: ['remoteConfig', 'remoteConfigAtom', 'port'],
    public: true,
};
export default remoteConfigPlugin;
